import React from 'react';
import Document from '../../Cell/Document';
import Number from '../../Cell/Number';
import Text from '../../Cell/Text';
import Module from '../../Cell/Module';
import Chance from '../../Cell/Chance';
import Difficulty from '../../Cell/Difficulty';
import DocumentList from '../../Cell/DocumentList';

const ALevel = ({ row }) => {
  const {
    topic,
    chapter,
    module,
    likelihood,
    difficulty,
    percent,
    examQuestions,
    hardestExamQuestionsEver,
    questionsByDifficulty,
    questionsByDifficultyMs,
    videoExplanation,
    cheatSheets,
  } = row;

  return (
    <tr>
      <td>{topic}</td>
      <td>
        <Number
          block={{
            value: chapter,
            displayAs: 'chapter',
          }}
        />
      </td>
      <td>
        <Module
          block={{
            text: module?.title,
            textClassName: module?.title?.toLowerCase().split(' ').join('-'),
          }}
        />
      </td>
      <td>
        <Difficulty
          block={{
            text: difficulty?.title?.toLowerCase().split(' ').join('-'),
          }}
        />
      </td>
      <td>
        <Number
          block={{
            value: percent,
            displayAs: 'percent',
          }}
        />
      </td>
      <td>
        <DocumentList documents={examQuestions} />
      </td>
      <td>
        <Document document={hardestExamQuestionsEver} />
      </td>
      <td>
        <DocumentList documents={questionsByDifficulty} />
      </td>
      <td>
        <DocumentList documents={questionsByDifficultyMs} />
      </td>
      <td>
        <Document document={cheatSheets} />
      </td>
      <td>
        <Text
          isVideoExplanation
          block={{
            body: videoExplanation,
          }}
        />
      </td>
    </tr>
  );
};

export default ALevel;
